module.exports = __webpack_public_path__ + "static/media/Hero__MGD--1.7102386f.jpeg";